import React from 'react';

import cadet from '../assets/ranks/cadet.png';
import officer from '../assets/ranks/officer.png';
import sergeant from '../assets/ranks/sergeant.png';
import goldshield from '../assets/ranks/goldshield.png';
import lieutenant from '../assets/ranks/lieutenant.png';
import captain from '../assets/ranks/captain.png';
import commander from '../assets/ranks/commander.png';
import chief from '../assets/ranks/chief.png';

// Rank icon key -> imported PNG insignia + hero-glow flag.
const RANK_IMAGES = {
  cadet:      { src: cadet,      glow: false },
  officer:    { src: officer,    glow: false },
  sergeant:   { src: sergeant,   glow: false },
  goldshield: { src: goldshield, glow: true },
  lieutenant: { src: lieutenant, glow: false },
  captain:    { src: captain,    glow: false },
  commander:  { src: commander,  glow: false },
  chief:      { src: chief,      glow: true },
};

const SIZE_PX = { xs: 18, sm: 24, md: 52, lg: 96, xl: 140 };

export const RankBadge = ({ rank, size = 'md', showName = false, locked = false }) => {
  if (!rank) return null;
  const key = rank.icon && RANK_IMAGES[rank.icon] ? rank.icon : 'cadet';
  const spec = RANK_IMAGES[key];
  const px = SIZE_PX[size] || SIZE_PX.md;
  const tiny = size === 'sm';

  return (
    <div
      className={`inline-flex flex-col items-center gap-1.5 transition-transform duration-300 ${!locked && !tiny ? 'hover:scale-105 hover:-translate-y-0.5' : ''}`}
      data-testid={`rank-badge-${rank.rankName || key}`}
    >
      <img
        src={spec.src}
        alt={rank.rankName || key}
        width={px}
        height={px * 1.12}
        className={spec.glow && !locked ? 'rank-badge-glow' : ''}
        style={{
          height: px * 1.12,
          width: 'auto',
          objectFit: 'contain',
          imageRendering: 'auto',
          filter: locked
            ? 'grayscale(100%) opacity(0.4)'
            : (!tiny ? 'drop-shadow(0 4px 6px rgba(0,0,0,0.6))' : 'none'),
        }}
      />
      {showName && (
        <span className="text-xs font-headline tracking-widest uppercase text-amber-200">
          {rank.rankName}
        </span>
      )}
    </div>
  );
};

/**
 * Compact inline chip for chat / DMs. Renders nothing for the entry "Cadet"
 * rank (months === 0) to avoid clutter — only recognizes members with time served.
 */
export const RankChip = ({ rank, className = '' }) => {
  if (!rank || !rank.rankName || (rank.months || 0) <= 0) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 ${className}`}
      title={`${rank.rankName}${rank.isOG ? ' · OG' : ''}`}
      data-testid="rank-chip"
    >
      <RankBadge rank={rank} size="sm" />
      <span className="text-[9px] font-headline tracking-wider uppercase text-amber-300">
        {rank.isOG ? 'OG' : rank.rankName}
      </span>
    </span>
  );
};

export default RankBadge;
